'use client'

import { Checkbox } from '@fukku/checkbox'
import type { Choice } from 'product-list/types/Filters'
import { dataTestIds } from 'product-list/utils/testIds'
import { useCallback } from 'react'

import fukkuStyles from '@fukku/styles/classes.module.scss'
import styles from './MultipleChoice.module.scss'

interface MultipleChoiceProps {
	readonly a11yLabel: string
	readonly options: Choice[]
	readonly disabledValues: string[]
	readonly selectedValues: string[]
	readonly onChange?: (id: string) => void
}

export function MultipleChoice({
	options,
	disabledValues,
	selectedValues,
	onChange,
	a11yLabel,
}: MultipleChoiceProps) {
	const getDisabledCheckboxText = useCallback(
		(id: string, label: string) =>
			disabledValues.includes(id) ? `${label}, ${a11yLabel}` : label,
		[a11yLabel, disabledValues]
	)

	return (
		<fieldset
			className={styles.options}
			data-testid={dataTestIds.plpFilterGroup}
		>
			<legend className={fukkuStyles.srOnly}>{a11yLabel}</legend>
			{options.map(({ id, label }) => (
				<div key={id} data-testid={dataTestIds.plpFilterItem(id)}>
					<Checkbox
						id={id}
						className={styles.checkbox}
						aria-label={getDisabledCheckboxText(id, label)}
						disabled={disabledValues.includes(id)}
						checked={selectedValues.includes(id)}
						label={label}
						onChange={() => onChange?.(id)}
					/>
				</div>
			))}
		</fieldset>
	)
}
